import zhCN from './zh-CN'

export default {
  'zh-CN': zhCN,
}
